import VueRouter from 'vue-router'
import iView from 'iview'

import auth from '@/util/auth'
import store from '../store'

import { staticRoute , isStaticRoute, whiteList , createDynamicRoute , getNearestRoute , getExLink } from './router'

const router = new VueRouter({
  mode: 'history',
  routes: staticRoute
})

let lastRoute = { name: "dashboard" }

router.beforeEach((to, from, next) => {
  // NProgress.start()
  iView.LoadingBar.start()
  if(to.path && to.name != 'signin' && !to.path.startsWith('/error')){
    lastRoute = {
      path:to.path,
      params:to.params,
      query:to.query
    }
  }
  console.log(to)
  //next()
  //return
  store.dispatch('auth/status').then((status) => {
    // 登录状态
    if( status ){
      //拉取菜单 + 更新动态路由
      if( status == 2){
        router.addRoutes(createDynamicRoute( auth.getMenu() ) )
        try{
          next({ path: to.path, query:to.query , replace: true })
        }catch(e){}
      }
      //已登录且加载了菜单
      else{
        if (to.name === 'signin') {
          next({...lastRoute , replace:true})
          iView.LoadingBar.finish()
        } else {
          //无权限

          if( isStaticRoute(to.name) ){
            next()
          }else{
            if( auth.access(to.name , true) == false ){
              next({path:'/' , replace:true})
            }else{
              next()
            }
          }
        }
      }

    }
    //未登录
    else{
      if (whiteList.includes(to.name)) {
        next()
      }
      else{
        next({ name: "signin", replace: true })
        iView.LoadingBar.finish()
      }
      
    }
  })
})

router.afterEach(() => {
  iView.LoadingBar.finish()
  if(window && window.scrollTo) window.scrollTo(0, 0)
})

const setRouteByCode = (code , rest = {} , newwin = false) => {
  let name = getNearestRoute(code)
  console.log(name,code,'<<<<')
  if( name ){
    if( newwin ){
      let { href } = router.resolve({name , ...rest})
      window.open(href, '_blank');
    }else{
      router.push({name , ...rest})      
    }
  }
}

const getRouteByCode = (code) => {
  return getNearestRoute(code)
}

const setRoute = (name) => {
  let exLink = getExLink(name)
  if(exLink){
    window.open(exLink, '_blank');
  }else{
    router.push({name})      
  }
}

const direct = () => {
  router.push(lastRoute)
}

const reset = () => {
  router.push({
    name: 'signin'
  })
}


router.setRouteByCode = setRouteByCode

router.getRouteByCode = getRouteByCode

router.direct = direct

router.reset = reset

router.setRoute = setRoute

router.install = (Vue) => {
  Vue.use(VueRouter)
}

export default router